import React from 'react';

// Read-only functioning summary aggregated from canonical chart sources (evaluation,
// admission, PHQ-9). Never an eligibility, necessity, or level-of-care input.
export default function FunctioningOverview({ functioning }) {
  if (!functioning) return null;
  const phq9 = functioning.phq9;
  const hasData = !!functioning.evaluation || !!functioning.admission || !!(phq9 && phq9.functional_impairment);

  return (
    <div className="php-ov-section">
      <div className="content-heading"><div><h4>Functioning overview</h4><p>{functioning.note}</p></div></div>
      <p className="php-functioning-summary">{functioning.summary}</p>
      <ul className="php-checklist">
        {functioning.evaluation && <li className="done"><span className="php-checklist-mark">✓</span><span><strong>Evaluation.</strong> {functioning.evaluation}</span></li>}
        {functioning.admission && <li className="done"><span className="php-checklist-mark">✓</span><span><strong>Admission.</strong> {functioning.admission}</span></li>}
        {phq9 && phq9.functional_impairment && (
          <li className="done"><span className="php-checklist-mark">✓</span><span><strong>PHQ-9 ({phq9.severity || '—'}, {phq9.total != null ? phq9.total : '—'}/27).</strong> {phq9.functional_impairment}</span></li>
        )}
        {!hasData && <li className="todo"><span className="php-checklist-mark">⚠</span><span>No functioning data recorded yet.</span></li>}
      </ul>
    </div>
  );
}
